import React from 'react';
import { Section } from './ui/Section';
import { FadeIn } from './ui/FadeIn';
export const HowItWorks = () => {
  const steps = [{
    num: '1',
    text: 'Identifica el síntoma físico o pensamiento que te está robando la paz.'
  }, {
    num: '2',
    text: 'Abre la guía en la sección correspondiente y aplica el Método SOS.'
  }, {
    num: '3',
    text: 'Sigue la técnica de respiración indicada para resetear tu sistema nervioso.'
  }];
  return <Section variant="navy-light" data-id="element-65">
      <FadeIn data-id="element-66">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-16" data-id="element-67">
          Cómo funciona en <span className="text-gold" data-id="element-68">3 pasos</span>
        </h2>
      </FadeIn>

      <div className="grid md:grid-cols-3 gap-12 max-w-5xl mx-auto" data-id="element-69">
        {steps.map((step, idx) => <FadeIn key={idx} delay={idx * 0.2} className="relative flex flex-col items-center text-center" data-id="element-70">
            <div className="text-6xl md:text-8xl font-serif font-bold text-gold/20 mb-6 absolute -top-10 md:-top-16 z-0 select-none" data-id="element-71">
              {step.num}
            </div>
            <div className="relative z-10 mt-8" data-id="element-72">
              <p className="text-xl text-cream-muted font-medium leading-relaxed" data-id="element-73">
                {step.text}
              </p>
            </div>
          </FadeIn>)}
      </div>
    </Section>;
};